import React from "react";
import { MessageOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";

const CODE_ICON_MAP: Record<string, { icon: ReactNode }> = {
    "Action.Message.AutomatedResponse": {
        icon: React.createElement("div", { className: "automationIconsSprite automated-response-icon" }),
    },
    "Action.Notify.NotifyUser": {
        icon: React.createElement("div", { className: "automationIconsSprite notify-user-icon" }),
    },
    "Action.Crm.LogInCrm": {
        icon: React.createElement("div", { className: "automationIconsSprite add-note-icon" }),
    },
    "Action.Crm.CreateLead": {
        icon: React.createElement("div", { className: "automationIconsSprite create-lead-icon" }),
    },
    "Action.FlowControl.Delay": {
        icon: React.createElement("div", { className: "automationIconsSprite delay-icon" }),
    },
};


export function getActionIconAndClass(codeOrFormType: string | undefined): { icon: ReactNode } {
    const code = codeOrFormType?.startsWith("Action.") ? codeOrFormType : ACTION_CODE_TO_FORM_TYPE[codeOrFormType ?? ""];
    return CODE_ICON_MAP[code ?? ""] ?? { icon: React.createElement(MessageOutlined) };
}

export const ACTION_CODE_TO_FORM_TYPE: Record<string, string> = {
    "Action.Message.AutomatedResponse": "AutomatedResponse",
    "Action.Notify.NotifyUser": "NotifyUser",
    "Action.Crm.LogInCrm": "LogInCrm",
    "Action.Crm.CreateLead": "CreateLead",
    "Action.FlowControl.Delay": "Delay",
};

export const ACTION_CODE_TO_TITLE: Record<string, string> = {
    "Action.Message.AutomatedResponse": "Automated Response",
    "Action.Notify.NotifyUser": "Notify User",
    "Action.Crm.LogInCrm": "Log in CRM",
    "Action.Crm.CreateLead": "Create Lead",
    "Action.FlowControl.Delay": "Delay",
};

export function actionCodeToTitle(code: string | undefined): string | undefined {
    return code ? ACTION_CODE_TO_TITLE[code] : undefined;
}

export function getFormTypeForAction(codeOrType: string): string {
    if (ACTION_CODE_TO_FORM_TYPE[codeOrType]) {
        return ACTION_CODE_TO_FORM_TYPE[codeOrType];
    }
    return codeOrType;
}
